import React, { createContext, useState } from 'react';

export type ApplicationContext = {
  language: string;
};

// eslint-disable-next-line no-redeclare
export const ApplicationContext = createContext<ApplicationContext>({
  language: 'en',
});

interface Props {
  children: React.ReactNode;
}

const ApplicationContextProvider = (props: Props): React.JSX.Element => {
  const [appContext, setAppContext] = useState<ApplicationContext>({
    language: 'en',
  });

  return (
    <ApplicationContext.Provider value={appContext}>
      {props.children}
    </ApplicationContext.Provider>
  );
};


export default ApplicationContextProvider;
